import React from 'react';
import { useNotificationPermission } from '../hooks/useNotificationPermission';

const NotificationPermissionPrompt: React.FC = () => {
  const { shouldShowPrompt, requestPermission, dismissPrompt } = useNotificationPermission();

  if (!shouldShowPrompt) return null;

  return (
    <div
      className="overlay-notification fixed bottom-4 left-4 right-4 z-[1060] mx-auto max-w-lg rounded-xl border border-border-muted bg-surface-elevated p-4 shadow-xl max-lg:bottom-[calc(1rem+env(safe-area-inset-bottom,0px))]"
      dir="rtl"
      role="region"
      aria-label="درخواست اجازه اعلان"
    >
      <p className="text-sm font-medium text-content-primary">برای دریافت اعلان‌های مهم، اجازه ارسال notification را فعال کنید.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          className="rounded-lg bg-gradient-to-l from-chart-color-1 to-chart-color-2 px-4 py-2 text-sm font-semibold text-white"
          style={{ minHeight: 'var(--touch-target-min, 44px)' }}
          onClick={() => requestPermission()}
        >
          فعال‌سازی
        </button>
        <button
          type="button"
          className="rounded-lg border border-border-muted bg-surface-secondary px-4 py-2 text-sm text-content-secondary"
          style={{ minHeight: 'var(--touch-target-min, 44px)' }}
          onClick={dismissPrompt}
        >
          بعداً
        </button>
      </div>
    </div>
  );
};

export default NotificationPermissionPrompt;
